import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container d-flex justify-content-center align-items-center",
  style: {"min-height":"100vh"}
}

import { SignIn } from '@clerk/vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'SignIn',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(SignIn), {
      path: "/sign-in",
      routing: "path"
    })
  ]))
}
}

})